module.exports = __webpack_public_path__ + "static/media/404.bf2ba014.jpg";